export const followingEnglish = {
  FOLLOW_UNSUB_TITLE: "Weekly digest preferences",
  FOLLOW_UNSUB_HINT:
    "Confirm below to stop the weekly Following email digest. Your follows and app notifications will stay unchanged.",
  FOLLOW_UNSUB_CONFIRM: "Stop weekly digest",
  FOLLOW_UNSUB_DONE: "Your weekly Following email digest is now turned off.",
  FOLLOW_UNSUB_ERROR:
    "This link is unavailable or has expired. Sign in to manage your notification preferences.",
  FOLLOW_UNSUB_SETTINGS: "Sign in to manage preferences",
  FOLLOW_UNSUB_RETRY: "Check link again",
  FOLLOW_LANGUAGE_EN: "English",
  FOLLOW_LANGUAGE_DE: "Deutsch",
  FOLLOW_ACTION: "Follow",
  FOLLOW_FOLLOWING: "Following",
  FOLLOW_UNFOLLOW: "Unfollow",
  FOLLOW_PENDING: "Saved — checking membership…",
  FOLLOW_UNAVAILABLE: "Following is unavailable",
  FOLLOW_RECONCILE:
    "Could not confirm your change. Refresh the current state before trying again.",
  FOLLOW_YOUR_LIST: "Your Following list",
  FOLLOW_NONE:
    "You aren't following anyone yet. Follow someone from their profile or a post menu.",
  FOLLOW_NO_POSTS: "No posts to show yet.",
  FOLLOW_APP_ALERTS: "App notifications",
  FOLLOW_DIGEST: "Weekly email digest",
  FOLLOW_ON: "On",
  FOLLOW_OFF: "Off",
  FOLLOW_FOLLOWERS_COUNT: "Followers: {{count}}",
  FOLLOW_FOLLOWING_COUNT: "Following: {{count}}",
  FOLLOW_SETTINGS: "Following notifications",
  FOLLOW_SETTINGS_HINT:
    "These controls apply to people you follow. Your existing notification mute is always respected.",
  FOLLOW_BATCH: "{{author}} published {{count}} new post",
  FOLLOW_BATCH_other: "{{author}} published {{count}} new posts",
  FOLLOW_RETRY_ALERTS: "Refresh follower notifications",
  FOLLOW_RETRY_ENRICHMENT: "Refresh additional Following posts",
  FOLLOW_SEARCH: "Search followed authors' posts",
};
export const followingGerman = {
  FOLLOW_UNSUB_TITLE: "Einstellungen für den Wochenrückblick",
  FOLLOW_UNSUB_HINT:
    "Bestätige unten, um den wöchentlichen E-Mail-Rückblick zu beenden. Deine Abonnements und App-Benachrichtigungen bleiben unverändert.",
  FOLLOW_UNSUB_CONFIRM: "Wochenrückblick abbestellen",
  FOLLOW_UNSUB_DONE:
    "Dein wöchentlicher E-Mail-Rückblick ist jetzt deaktiviert.",
  FOLLOW_UNSUB_ERROR:
    "Dieser Link ist nicht verfügbar oder abgelaufen. Melde dich an, um deine Benachrichtigungseinstellungen zu verwalten.",
  FOLLOW_UNSUB_SETTINGS: "Anmelden und Einstellungen verwalten",
  FOLLOW_UNSUB_RETRY: "Link erneut prüfen",
  FOLLOW_LANGUAGE_EN: "English",
  FOLLOW_LANGUAGE_DE: "Deutsch",
  FOLLOW_ACTION: "Folgen",
  FOLLOW_FOLLOWING: "Gefolgt",
  FOLLOW_UNFOLLOW: "Nicht mehr folgen",
  FOLLOW_PENDING: "Gespeichert — Mitgliedschaft wird geprüft…",
  FOLLOW_UNAVAILABLE: "Folgen ist nicht verfügbar",
  FOLLOW_RECONCILE:
    "Deine Änderung konnte nicht bestätigt werden. Aktualisiere den Status, bevor du es erneut versuchst.",
  FOLLOW_YOUR_LIST: "Personen, denen du folgst",
  FOLLOW_NONE:
    "Du folgst noch niemandem. Folge jemandem über das Profil oder ein Beitragsmenü.",
  FOLLOW_NO_POSTS: "Noch keine Beiträge vorhanden.",
  FOLLOW_APP_ALERTS: "App-Benachrichtigungen",
  FOLLOW_DIGEST: "Wöchentliche E-Mail-Zusammenfassung",
  FOLLOW_ON: "Ein",
  FOLLOW_OFF: "Aus",
  FOLLOW_FOLLOWERS_COUNT: "Follower: {{count}}",
  FOLLOW_FOLLOWING_COUNT: "Gefolgt: {{count}}",
  FOLLOW_SETTINGS: "Benachrichtigungen zu gefolgten Personen",
  FOLLOW_SETTINGS_HINT:
    "Diese Einstellungen gelten für Personen, denen du folgst. Deine bestehende Stummschaltung bleibt wirksam.",
  FOLLOW_BATCH: "{{author}} hat {{count}} neuen Beitrag veröffentlicht",
  FOLLOW_BATCH_other: "{{author}} hat {{count}} neue Beiträge veröffentlicht",
  FOLLOW_RETRY_ALERTS: "Follower-Benachrichtigungen aktualisieren",
  FOLLOW_RETRY_ENRICHMENT: "Weitere Beiträge aktualisieren",
  FOLLOW_SEARCH: "Beiträge gefolgter Personen durchsuchen",
};
